import { useState, useEffect, useRef, useCallback } from 'react';

import { useApolloClient } from '@apollo/client/react';

import { ProductTagsSelectQuery, ProductTagsSelectQueryVariables } from '@anyx/common-graphql';


import { PRODUCT_TAGS_SELECT } from '../graphql';

export const useProductTagSelect = ({
  storeIds,
  accountId,
}: {
  storeIds: string[] | null;
  accountId: string | null;
}) => {
  const [tags, setTags] = useState<string[]>([]);
  const client = useApolloClient();

  const prevStoreIds = useRef<string[] | null>(null);

  const fetchTags = useCallback(async () => {
    try {
      const { data } = await client.query<ProductTagsSelectQuery, ProductTagsSelectQueryVariables>({
        query: PRODUCT_TAGS_SELECT,
        variables: {
          filter: {
            ...(accountId ? { masterDataAccountId: accountId } : {}),
            ...((storeIds || []).length > 0 ? { masterDataStoreIds: storeIds } : {}),
          },
        },
        fetchPolicy: 'network-only',
      });
      setTags([...(data?.tagsV2 || [])]);
    } catch (error) {
      console.error('[useProductTagSelect] Error fetching tags:', error);
    }
  }, [client, accountId, storeIds]);

  useEffect(() => {
    if (prevStoreIds.current?.every((value) => storeIds?.includes(value))) {
      return;
    }
    prevStoreIds.current = storeIds;

    fetchTags();
  }, [accountId, fetchTags, storeIds]);

  return { tags };
};
